import { useLocation } from 'react-router-dom'
import { useAuth } from '@/app/providers/auth-context'
import { resolveStaffClub, type StaffClub } from './staffClub'

/** The club header context for the player card route; `null` anywhere else (see `resolveStaffClub`). */
export function useStaffClub(): StaffClub | null {
  const { pathname, search } = useLocation()
  const { state, organizations, isClubStaff } = useAuth()
  if (state !== 'authenticated' || !/^\/players\/[^/]+/.test(pathname) || /^\/players\/(edit|new|all|view)(\/|$)/.test(pathname)) return null
  const orgId = new URLSearchParams(search).get('orgId')
  return resolveStaffClub(orgId, Boolean(orgId) && isClubStaff(orgId ?? ''), organizations)
}
